
/* Set up category selector used on homepage */
jQuery(function ($) {
            
        setupCategorySlider($)
        changeHexClass($),
        changeHexFontSize($),
        $(window).on('resize', function (e) {
            changeHexClass($), changeHexFontSize($);
        })

});

/* Slide-toggle category types */
function setupCategorySlider($) {
    
    const byGradeButton   = $('.by-grade-button'),
          bySubjectButton = $('.by-subject-button'),
          byTypeButton    = $('.by-type-button'),
          categoryLists   = $('.category-lists');
    
    if (byGradeButton.length && bySubjectButton.length &&
        byTypeButton.length && categoryLists.length) {

        byGradeButton.click(function (event) {
            event.preventDefault();

            byGradeButton.addClass('selected');
            bySubjectButton.removeClass('selected');
            byTypeButton.removeClass('selected');

            categoryLists.slideToggle();

            setTimeout(function () {
                categoryLists.addClass('by-grade');
                categoryLists.removeClass('by-subject');
                categoryLists.removeClass('by-type');
            }, 1000);
            
            setTimeout(function () { categoryLists.slideToggle(); }, 1000);
            
        });

        bySubjectButton.click(function (event) {
            event.preventDefault();

            bySubjectButton.addClass('selected');
            byGradeButton.removeClass('selected');
            byTypeButton.removeClass('selected');

            categoryLists.slideToggle();

            setTimeout(function () {
                categoryLists.addClass('by-subject');
                categoryLists.removeClass('by-grade');
                categoryLists.removeClass('by-type');
            }, 1000);

            setTimeout(function () { categoryLists.slideToggle(); }, 1000);
        });

        byTypeButton.click(function (event) {
            event.preventDefault();

            byTypeButton.addClass('selected');
            bySubjectButton.removeClass('selected');
            byGradeButton.removeClass('selected');

            categoryLists.slideToggle();

            setTimeout(function () {
                categoryLists.addClass('by-type');
                categoryLists.removeClass('by-grade');
                categoryLists.removeClass('by-subject');
            }, 1000);

            setTimeout(function () { categoryLists.slideToggle(); }, 1000);
        });
    }

}

/* Make hexagons mobile-friendly */
function changeHexFontSize($) {
    
    const hexagons = $('.hexagon p');
    
    hexagons.each(function () {
		let el = $(this);
		let textLength = el.html().length;
		
		if ( $( window ).width() < 800 ) {
			if ( textLength > 40 ) {
				el.css('font-size', '0.6rem');
			} else if (textLength > 36) {
			    el.css('font-size', '.7rem');
			} else if (textLength > 30) {
			    el.css('font-size', '8rem');
			} else if (textLength > 14) {
			    el.css('font-size', '.9rem');
			}

		} else {
			if ( textLength > 40 ) {
			    el.css('font-size', '0.8rem');
			} else if (textLength > 36) {
			    el.css('font-size', '.9rem');
			} else if (textLength > 30) {
			    el.css('font-size', '1rem');
			} else if (textLength > 14) {
			    el.css('font-size', '1.1rem');
			}
		}
	});
}

function changeHexClass($) {
    const hexagons = $('ul.hexagon');
	hexagons.each(function() {
		if( jQuery(this).width() > 500 ) {
			hexagons.addClass('three-wide');
			hexagons.removeClass('two-wide');
		} else {
			hexagons.addClass('two-wide');
			hexagons.removeClass('three-wide');
		}
	})
}

